import { useState } from "react";
import { submitRegistration } from "../../utils/registrationService";
import { RegistrationDto } from "../../utils/types/registration";

const Contact = () => {
  const [form, setForm] = useState({
    fullName: "",
    agencyName: "",
    agencyType: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showToast, setShowToast] = useState(false);  
  
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const validate = () => {
  const newErrors: { [key: string]: string } = {};

  if (!form.fullName.trim()) newErrors.fullName = "Задолжително поле";
  if (!form.agencyName.trim()) newErrors.agencyName = "Задолжително поле";
  if (!form.agencyType) newErrors.agencyType = "Задолжително поле";
  if (!form.email.trim()) newErrors.email = "Задолжително поле";
  else if (!/\S+@\S+\.\S+/.test(form.email))
    newErrors.email = "Невалиден мејл";

  return newErrors;
};

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setErrors({});
  setLoading(true);

  const payload: RegistrationDto = {
    name: form.fullName,
    agencyName: form.agencyName,
    agencyType: form.agencyType === "organizer" ? 0 : 1,
    email: form.email,
    phone: form.phone || undefined,
    location: 4, //Merakzy.com 
    message: form.message 
  };

  try {
    await submitRegistration(payload);
    setSubmitted(true);

    setForm({
      fullName: "",
      agencyName: "",
      agencyType: "",
      email: "",
      phone: "",
      message: "",
    });

    setShowToast(true);
    setTimeout(() => setShowToast(false), 4000);
  } catch (error) {
    console.error(error);
    alert(
      "Се случи неочекувана грешка. Ве молиме обидете се повторно."
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <section className="bg-white py-16 md:py-24 px-4">
      <div className="max-w-4xl mx-auto text-center">

        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-semibold text-[#0c0407] mb-6">
          Сакате да дознаете повеќе?
        </h1>

        {/* Subtitle */}
        <p className="text-[#0C0407] text-base md:text-lg mb-10">
          Пишете ни, прашајте нè или побарајте демо, а ние ќе ви одговориме во најбрзо време!
        </p>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-5 text-left"
        >
          {/* Full name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Име и презиме*
            </label>
            <input
              name="fullName"
              placeholder="Вашето целосно име"
              className={`w-full h-12 rounded-[16px] px-5 border focus:outline-none focus:ring-2 focus:ring-[#fa0053]
              ${errors.fullName ? "border-red-500" : "border-gray-300"}`}
              value={form.fullName}
              onChange={handleChange}
            />
          </div>

          {/* Agency name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Име на агенцијата*
            </label>
            <input
              name="agencyName"
              placeholder="Име на агенцијата"
              className={`w-full h-12 rounded-[16px] px-5 border focus:outline-none focus:ring-2 focus:ring-[#fa0053]
              ${errors.agencyName ? "border-red-500" : "border-gray-300"}`}
              value={form.agencyName}
              onChange={handleChange}
            />
          </div>

          {/* Agency type */}
          <div>
            <span className="block text-sm font-semibold mb-2">
              Тип на агенцијата*
            </span>

            <div className="flex flex-col gap-2 text-sm">
              <label className="flex items-start gap-3">
                <input
                  type="radio"
                  name="agencyType"
                  value="organizer"
                  className="mt-1 accent-[#fa0053]"
                  checked={form.agencyType === "organizer"}
                  onChange={handleChange}
                />
                <span>
                  <span className="font-bold">Организатор</span>. Имам сопствени соби на закуп.
                </span>
              </label>

              <label className="flex items-start gap-3">
                <input
                  type="radio"
                  name="agencyType"
                  value="reseller"
                  className="mt-1 accent-[#fa0053]"
                  checked={form.agencyType === "reseller"}
                  onChange={handleChange}
                />
                <span>
                  <span className="font-bold">Туристичка агенција</span>. Препродавам аранжмани.
                </span>
              </label>
            </div>

            {errors.agencyType && (
              <p className="text-red-500 text-xs mt-1">{errors.agencyType}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Мејл*
            </label>
            <input
              type="email"
              name="email"
              placeholder="Вашата мејл адреса"
              className={`w-full h-12 rounded-[16px] px-5 border focus:outline-none focus:ring-2 focus:ring-[#fa0053]
              ${errors.email ? "border-red-500" : "border-gray-300"}`}
              value={form.email}
              onChange={handleChange}
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Телефон*
            </label>
            <input
              name="phone"
              placeholder="000 000 000"
              className="w-full h-12 rounded-[16px] px-5 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#fa0053]"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          {/* Message */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Порака
            </label>
            <textarea
              name="message"
              placeholder="Порака"
              rows={4}
              className="w-full rounded-[16px] px-5 py-3 border border-gray-300 resize-none focus:outline-none focus:ring-2 focus:ring-[#fa0053]"
              value={form.message}
              onChange={handleChange}
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            className="mt-6 h-12 rounded-[16px] text-white font-semibold transition hover:opacity-90"
            style={{
              background: "linear-gradient(90deg, #FA0053 0%, #B6003C 100%)",
            }}
          >
            Испратете
          </button>
        </form>
      </div>
      {showToast && (
        <div className="fixed bottom-6 left-1/2 z-50 rounded-[16px] bg-[#fa0053] text-white px-6 py-4 shadow-lg transform -translate-x-1/2">
            Формата е успешно испратена!
          </div>
      )}
    </section>
  );
};

export default Contact;